var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox-container" }, [
    _c(
      "div",
      {
        staticClass: "checkbox-input-container",
        style: [
          { height: _vm.height - 1 + "px", "min-width": _vm.width - 1 + "px" }
        ],
        on: {
          click: function($event) {
            _vm.disabled ? null : _vm.$emit("update-value")
          }
        }
      },
      [
        _c("input", {
          key: _vm.label,
          staticClass: "checkbox-default-styling",
          class: { disabled: _vm.disabled, checked: _vm.value },
          style: [
            {
              height: _vm.height + "px",
              width: _vm.width + "px",
              border: _vm.border
            },
            _vm.checkboxStyle
          ],
          attrs: { type: "checkbox" },
          domProps: { value: _vm.value }
        }),
        _vm._v(" "),
        _vm.value === true && _vm.indeterminate === false
          ? _c("img", {
              staticClass: "check-logo",
              style: [_vm.checkboxIconStyle],
              attrs: {
                src: require("../../assets/check-bold.png"),
                alt: "checked"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.value === true && _vm.indeterminate === true
          ? _c("img", {
              staticClass: "check-logo",
              style: [_vm.checkboxIconStyle],
              attrs: {
                src: require("../../assets/indeterminate.png"),
                alt: "checked"
              }
            })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "checkbox-label v-label",
        style: _vm.checkboxLabelStyle,
        attrs: { for: "" }
      },
      [_vm._v(_vm._s(_vm.label))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cd5ecc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd5ecc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Atoms/CustomCheckbox.vue
// module id = null
// module chunks = 